module.exports = __webpack_public_path__ + "static/media/2DGACM9.a12821e3.jpg";